import { render, staticRenderFns } from "./BarCharts.vue?vue&type=template&id=24a90507&scoped=true&"
import script from "./BarCharts.vue?vue&type=script&lang=js&"
export * from "./BarCharts.vue?vue&type=script&lang=js&"
import style0 from "./BarCharts.vue?vue&type=style&index=0&id=24a90507&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a90507",
  null
  
)

export default component.exports